import { useInView } from '../hooks/useInView';
import { useAnimatedNumber } from '../hooks/useAnimatedNumber';
import { LANDING_STATS, LANDING_TESTIMONIAL } from '../constants/posLandingConst';

/**
 * One figure in the proof strip, counting up from zero the first time it
 * scrolls into view.
 *
 * @param {object} props
 * @param {number} props.to
 * @param {string} props.suffix - e.g. '%'
 * @param {string} props.label
 * @returns {JSX.Element}
 */
function PosLandingStat({ to, suffix, label }) {
  const [ref, seen] = useInView({ threshold: 0.5 });
  const value = useAnimatedNumber(seen ? to : 0, 1100);
  return (
    <div className="stat">
      <b><span className="count" ref={ref}>{value.toLocaleString('en-PH')}</span>{suffix}</b>
      <small>{label}</small>
    </div>
  );
}

/**
 * The strip under the hero: a customer's word and three running totals.
 *
 * @returns {JSX.Element}
 */
function PosLandingProof() {
  return (
    <div className="proof">
      <div className="wrap proof-in">
        <q>{LANDING_TESTIMONIAL.quote}<cite>{LANDING_TESTIMONIAL.cite}</cite></q>
        <div className="stats">
          {LANDING_STATS.map((stat) => <PosLandingStat key={stat.label} {...stat} />)}
        </div>
      </div>
    </div>
  );
}

export default PosLandingProof;
